const AUTH_STORAGE_KEYS = [
    "token",
    "refreshToken",
    "refresh_token",
    "id",
    "userID",
    "username",
    "sync",
    "roleid",
    "staffid",
    "selectedMenu",
];

function decodeBase64Url(value) {
    const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
    return atob(padded);
}

export function decodeJwtPayload(token) {
    if (!token || typeof token !== "string") {
        return null;
    }

    const parts = token.split(".");
    if (parts.length !== 3) {
        return null;
    }

    try {
        return JSON.parse(decodeBase64Url(parts[1]));
    } catch (error) {
        return null;
    }
}

export function getTokenExpiryMs(token) {
    const payload = decodeJwtPayload(token);
    if (!payload || typeof payload.exp !== "number") {
        return null;
    }

    return payload.exp * 1000;
}

export function isTokenExpired(token) {
    const expiryMs = getTokenExpiryMs(token);
    if (!expiryMs) {
        return false;
    }

    return expiryMs <= Date.now();
}

export function clearAuthStorage() {
    AUTH_STORAGE_KEYS.forEach((key) => {
        localStorage.removeItem(key);
    });
}

export function markLogoutSignal() {
    localStorage.setItem("logoutSignal", String(Date.now()));
}
